import { inject } from '@angular/core'
import { InMemoryCache } from '@apollo/client/core'
import { ErrorLink } from '@apollo/client/link/error'
import { provideNamedApollo } from 'apollo-angular'
import { HttpLink } from 'apollo-angular/http'
import { environment } from '../../../environments/environment'
import { ErrorHandlerService } from '../services/error-handler/error-handler.service'

export function provideApollo() {
  return provideNamedApollo(() => {
    const httpLink = inject(HttpLink)
    const errorHandlerService = inject(ErrorHandlerService)

    const httpSammathnaur = httpLink.create({
      uri: environment.SAMMATHNAUR_BASE_URL,
    })

    const httpMordu = httpLink.create({
      uri: environment.MORDU_BASE_URL,
    })

    const errorLink = new ErrorLink((data) => {
      errorHandlerService.handleError(data)
    })

    return {
      sammathnaur: {
        name: 'sammathnaur',
        cache: new InMemoryCache(),
        link: errorLink.concat(httpSammathnaur),
        defaultOptions: {
          watchQuery: {
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
          },
          query: {
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
          },
          mutate: {
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
          },
        },
      },
      mordu: {
        name: 'mordu',
        cache: new InMemoryCache(),
        link: errorLink.concat(httpMordu),
        defaultOptions: {
          watchQuery: {
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
          },
          query: {
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
          },
          mutate: {
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
          },
        },
      },
    }
  })
}
